// @flow
import React, { lazy } from 'react';
// import { PrivateRoute, RoutesHandler } from '@shared/helper/privateRoute';
import { PrivateRoute, RoutesHandler } from '@fino/shared';
import { useRecoilState } from 'recoil';
import { Navigate } from 'react-router-dom';
import { authDataState,userDataState } from '../store';
// import LoadingPage from '@auth/components/loadingPage';

// const General = lazy(() => import('./general'));
// const Panel = lazy(() => import('./panel'));
const Auth = lazy(() => import('../modules/auth/src/App'));
const Admin = lazy(() => import('../modules/admin/src/App'));
const Customer = lazy(() => import('../modules/customer/src/App'));
const SuperAdmin = lazy(() => import('../modules/processMaker/src/App'));
const Provider = lazy(() => import('../modules/provider/src/App'));

function AppRoutes(): React$Node {

	const [{ token }] = useRecoilState(authDataState);
	const [userData] = useRecoilState(userDataState);

	const superAdminAccess = Boolean(token && (userData?.roles?.includes('SuperAdmin')))
	const adminAccess = Boolean(token && (userData?.roles?.includes('FundUser')))
	const customerAccess = Boolean(token && (userData?.roles?.includes('Customer')))
	const providerAccess = Boolean(token && (userData?.roles?.includes('ProviderUser')))

	const routes = [
		{
			path: '*',
			component: <Navigate to={'/auth/login'} replace />,
		},
		// {
		//     path: '/general/*',
		//     component: <React.Suspense fallback={<LoadingPage />}>
		//         <General />
		//     </React.Suspense>,
		// },
		{
			path: '/auth/*',
			component: (
				<React.Suspense fallback={<div>{'....'}</div>}>
					{/* <PrivateRoute isPrivate={!token} pathname={'/admin/dashboard'}> */}
					<Auth />
					{/* </PrivateRoute> */}
				</React.Suspense>
			),
		},
		{
			path: '/superAdmin/*',
			component: (
				<React.Suspense fallback={<div>{'....'}</div>}>
					<PrivateRoute isPrivate={superAdminAccess} pathname={'../../auth/login'}>
						<SuperAdmin />
					</PrivateRoute>
				</React.Suspense>
			),
		},
		{
			path: '/admin/*',
			component: (
				<React.Suspense fallback={<div>{'....'}</div>}>
					<PrivateRoute isPrivate={adminAccess} pathname={'../../auth/login'}>
						<Admin />
					</PrivateRoute>
				</React.Suspense>
			),
		},
		{
			path: '/customer/*',
			component: (
				<React.Suspense fallback={<div>{'....'}</div>}>
					<PrivateRoute isPrivate={customerAccess} pathname={'../../auth/login'}>
						<Customer />
					</PrivateRoute>
				</React.Suspense>
			),
		},
		{
			path: '/provider/*',
			component: (
				<React.Suspense fallback={<div>{'....'}</div>}>
					<PrivateRoute isPrivate={providerAccess} pathname={'../../auth/login'}>
						<Provider />
					</PrivateRoute>
				</React.Suspense>
			),
		},
	];

	return (
		<RoutesHandler routes={routes} />
	);
}

export default AppRoutes;
